import { FormikValues, useFormikContext } from 'formik';
import React, { ChangeEvent } from 'react';

import Ajuda from './Ajuda';

interface Props {
    ajuda?: string;
    name: string;
    multiple?: boolean
}

const Arquivo = ({ ajuda, name, multiple = false }: Props): React.ReactElement =>
{
    const {
        errors,
        touched,
        values,
        setValues,
        setFieldTouched,
    } = useFormikContext<FormikValues>();

    return (
        <React.Fragment>
            <div className="position-relative mb-3">
                <input
                    type="file"
                    name={ name }
                    className={ `form-control ${ errors[name] && touched[name] && 'is-invalid' }` }
                    onChange={ (e: ChangeEvent<HTMLInputElement>) => {
                        const dados = { ...values };
                        dados[name] = multiple ? e.currentTarget.files : e.currentTarget.files?.item(0);

                        setFieldTouched(name, true, true);
                        setValues(dados);
                    } }
                />
                <React.Fragment>
                    { ajuda && (
                        <Ajuda>{ ajuda }</Ajuda>
                    ) }
                </React.Fragment>
                <div className="invalid-tooltip">
                    { errors[name] && touched[name] && errors[name] }
                </div>
            </div>
        </React.Fragment>
    );
}

export default Arquivo;
